import { useAuth } from 'contexts/auth'
import AuthenticationLayout from 'layouts/authentication'
import DefaultLayout from 'layouts/default'
import PermissionLayout from 'layouts/permission'

import React, { PropsWithChildren } from 'react'
import { Route as ReactDOMRoute, RouteProps as ReactDOMRouteProps, Redirect } from 'react-router-dom'

interface RouteProps extends ReactDOMRouteProps {
  useDefaultLayout?: boolean
  isPrivate?: boolean
  isExternal?: boolean
  isPermission?: boolean
  component: React.FC<{}>
}

const Route = ({
  useDefaultLayout = false,
  isPrivate = false,
  isExternal = false,
  isPermission = false,
  component: Component,
  ...rest
}: RouteProps) => {
  const { user } = useAuth()

  let Layout: React.FC<PropsWithChildren>

  if (isExternal) {
    Layout = AuthenticationLayout

    return (
      <ReactDOMRoute
        {...rest}
        render={({ location }) => (
          <Layout>
            <Component />
          </Layout>
        )}
      />
    )
  }

  if (isPermission) {
    Layout = PermissionLayout

    return (
      <ReactDOMRoute
        {...rest}
        render={({ location }) => {
          return !!user ? (
            <Layout>
              <Component />
            </Layout>
          ) : (
            <Redirect
              to={{
                pathname: '/dashboard',
                state: { from: location },
              }}
            />
          )
        }}
      />
    )
  }

  Layout = useDefaultLayout ? DefaultLayout : AuthenticationLayout

  return (
    <ReactDOMRoute
      {...rest}
      render={({ location }) => {
        return isPrivate === !!user ? (
          <Layout>
            <Component />
          </Layout>
        ) : (
          <Redirect
            to={{
              pathname: isPrivate ? '/' : '/dashboard',
              state: { from: location },
            }}
          />
        )
      }}
    />
  )
}

export default Route
